import axios from '@/axios/api.request'

export const statis = (params) => axios.request({
    url: 'dashboard/statis',
    data: params,
    method: 'post'
  })

  export const target = (params) => axios.request({
    url: 'dashboard/target',
    data: params,
    method: 'post'
  })

  export const salary = (params) => axios.request({
    url: 'office/salary/byUid',
    data: params,
    method: 'post'
  })